import {
    RuleGroupType,
    TransactionRuleGroup,
} from "../../types/transactionRule";
import { TransactionRuleDto } from "./transaction-rule.dto";

export class TransactionRuleGroupDto {
    id: string;
    name: string;
    icon: string;
    order: number;
    rules?: TransactionRuleDto[];
    workspaceId: string;
    isDefault?: boolean;
    type: RuleGroupType;

    constructor(group: TransactionRuleGroup) {
        this.id = group.id;
        this.workspaceId = group.workspaceId;
        this.rules = group.rules?.map((rule) => new TransactionRuleDto(rule));
        this.order = group.order;
        this.name = group.name;
        this.icon = group.icon;
        this.isDefault = group.isDefault;
        this.type = group.type;
    }

    static deserialize(dto: TransactionRuleGroupDto): TransactionRuleGroup {
        return {
            ...dto,
            rules: dto.rules?.map(TransactionRuleDto.deserialize),
        };
    }
}
